import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-173" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-174" data-mp="2bfzls727p3ze">
        <header className="mx-auto max-w-narrow text-center" data-id="element-175" data-mp="2bffzke5j3tfk">
          <h2 className="font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-176" data-mp="2gdrdazyy2o32">
            ¿Te pasa alguno de estos?
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-blue-900/75 md:text-xl" data-id="element-177" data-mp="26gcy13orc5cc">
            Si respondés “sí” a más de 2, significa que ya no habitás cómodamente tu propio cuerpo.
          </p>
        </header>

        <ul className="mt-12 grid gap-4 md:mt-16 md:grid-cols-2" data-id="element-178" data-mp="1wruzyu7v4cce">
          {painPoints.map(point => <li key={point.title} className="flex gap-4 rounded-2xl bg-alert-50 px-5 py-5 ring-1 ring-alert-100 md:px-6" data-id="element-179" data-mp="1isd6i1jmgawp">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-alert-100 text-alert-600" data-id="element-180" data-mp="t9fakm1xag0q">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="oa2edap5vwlh" />
              </span>
              <span data-id="element-182" data-mp="12av7bqztejmh">
                <span className="block font-display text-lg font-extrabold tracking-tight text-ink" data-id="element-183" data-mp="12a3e2mtowxzd">
                  {point.title}
                </span>
                <span className="mt-1 block text-blue-900/75" data-id="element-184" data-mp="9lo9yvc3k02t">{point.description}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}